export const getClosestTimeSlotFromDate = (date: Date): string => {
  const targetMinutes = date.getHours() * 60 + date.getMinutes();

  let closest = TIME_SLOTS[0];
  let minDiff = Infinity;

  for (const slot of TIME_SLOTS) {
    const [h, m] = slot.split(":").map(Number);
    const slotMinutes = h * 60 + m;
    const diff = Math.abs(slotMinutes - targetMinutes);

    if (diff < minDiff) {
      minDiff = diff;
      closest = slot;
    }
  }

  return closest;
};

export const TIME_SLOTS = [
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
];

export const formatDisplayDateTime = (raw?: string | null | Date) => {
  if (!raw) return "";
  const d = typeof raw === "string" ? new Date(raw) : raw;
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
